// extracted by mini-css-extract-plugin
export var bubble = "directory-banner-module--bubble--d22cc";
export var buttonWrapper = "directory-banner-module--buttonWrapper--7fc9d";
export var heading = "directory-banner-module--heading--958b3";
export var leftSide = "directory-banner-module--leftSide--9f527";
export var mobileBannerImage = "directory-banner-module--mobileBannerImage--d6247";